import { Controller } from "@hotwired/stimulus"

// Minimal modal controller. Expects structure:
// <div data-controller="modal" data-modal-open-class="flex" class="hidden">
//   <div data-modal-target="backdrop" data-action="click->modal#close" class="fixed inset-0 bg-black/40"></div>
//   <div data-modal-target="panel" role="dialog" aria-modal="true" class="fixed inset-0 grid place-items-center p-4">
//     ... content ...
//     <button type="button" data-action="modal#close">Close</button>
//   </div>
// </div>
export default class extends Controller {
  static targets = ["backdrop", "panel", "overlay"]
  static values = { openClass: { type: String, default: "flex" } }

  // Utility to prevent link navigation bubbling from buttons inside link wrappers
  stop(event) {
    event.preventDefault()
    event.stopPropagation()
  }

  open() {
    const el = this.hasOverlayTarget ? this.overlayTarget : this.element
    el.classList.remove("hidden"); el.classList.add(this.openClassValue)
    // Prevent background scroll while modal is open
    document.body.classList.add("overflow-hidden")
  }
  close() {
    const el = this.hasOverlayTarget ? this.overlayTarget : this.element
    el.classList.add("hidden"); el.classList.remove(this.openClassValue)
    // Restore background scroll when modal closes
    document.body.classList.remove("overflow-hidden")
  }
}
